import script from "./CommitterStat.vue?vue&type=script&setup=true&lang=js"
export * from "./CommitterStat.vue?vue&type=script&setup=true&lang=js"

import "./CommitterStat.vue?vue&type=style&index=0&id=2d861a8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d861a8c"]])

export default __exports__